import React, { useState } from "react";
import {
    Grid,
    CircularProgress,
    Typography,
    Button,
    Tabs,
    Tab,
    TextField,
    Fade,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import ReCaptcha from "../../components/ReCaptcha";

// styles
import useStyles from "./styles";

// context
import { useUserDispatch, loginUser } from "../../context/UserContext";

function Login(props) {
    const classes = useStyles();

    // global
    const userDispatch = useUserDispatch();

    // local
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [activeTabId, setActiveTabId] = useState(0);
    const [loginValue, setLoginValue] = useState("");
    const [passwordValue, setPasswordValue] = useState("");
    const [reCaptCha, setRecaptcha] = useState("");
    const [errorMessages, setErrorMessages] = useState("");

    const handleChangeCapcha = (captcha) => {
        console.log(captcha)
        setRecaptcha(captcha)
    }

    const handleLogin = () => {
        loginUser(
            userDispatch,
            loginValue,
            passwordValue,
            reCaptCha,
            props.history,
            setIsLoading,
            setError,
            setErrorMessages
        )
    }

    return (
        <Grid container className={classes.container}>
            <div className={classes.formContainer}>
                <div className={classes.form}>
                    <Tabs
                        value={activeTabId}
                        onChange={(e, id) => setActiveTabId(id)}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab label="Login" classes={{ root: classes.tab }} />
                    </Tabs>
                    {
                        <React.Fragment>
                            <div className={classes.formDividerContainer}>
                                <div className={classes.formDivider} />
                                <div className={classes.formDivider} />
                            </div>
                            <Fade in={error}>
                                <Typography color="secondary" className={classes.errorMessage}>
                                    {errorMessages}
                                </Typography>
                            </Fade>
                            <TextField
                                id="text"
                                InputProps={{
                                    classes: {
                                        underline: classes.textFieldUnderline,
                                        input: classes.textField,
                                    },
                                }}
                                value={loginValue}
                                onChange={e => setLoginValue(e.target.value)}
                                margin="normal"
                                label="Username"
                                placeholder="Username"
                                type="text"
                                fullWidth
                            />
                            <TextField
                                id="password"
                                label="Password"
                                InputProps={{
                                    classes: {
                                        underline: classes.textFieldUnderline,
                                        input: classes.textField,
                                    },
                                }}
                                value={passwordValue}
                                onChange={e => setPasswordValue(e.target.value)}
                                margin="normal"
                                placeholder="Password"
                                type="password"
                                fullWidth
                            />
                            <ReCaptcha onChange={handleChangeCapcha} style={{ marginTop: 32}} />
                            <div className={classes.formButtons}>
                                {isLoading ? (
                                    <CircularProgress size={26} className={classes.loginLoader} />
                                ) : (
                                        <Button
                                            style={{ width: "100%", color: "white" }}
                                            disabled={
                                                loginValue.length === 0 || passwordValue.length === 0
                                            }
                                            onClick={handleLogin}
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                        >
                                            Login
                                        </Button>
                                    )}
                            </div>
                        </React.Fragment>
                    }
                </div>
                <Typography color="primary" className={classes.copyright}>
                    © {new Date().getFullYear()} Money Lover
        </Typography>
            </div>
        </Grid>
    );
}

export default withRouter(Login);
